@use '@lib/assets/styles/main.scss' as *;

.titleIcon {
  width: 48px;
  height: 48px;
  border-radius: 4px;
  border: 1px solid $gray200;
  object-fit: cover;
}

.titleRow {
  display: flex;
  align-items: center;
  gap: 12px;
}

.divider {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 4px 0;
}

.dividerLine {
  flex: 1;
  height: 1px;
  background-color: $gray200;
}

.dividerText {
  color: $gray400;
  text-transform: lowercase;
}

.attributeList {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.modalContentClassName {
  padding-top: 16px;
}
